/* Ingredients page: guarantee the 'A-Z index' and 'Explore ingredients' buttons
   jump to their targets even where smooth scrollIntoView is unavailable. */
(function () {
  function jump(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo(0, top < 0 ? 0 : top);
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest ? e.target.closest('[data-eri-scroll]') : null;
    if (!s) return;
    var id = s.getAttribute('data-eri-scroll');
    setTimeout(function () { jump(id); }, 0);
  });
})();

/* Ingredients page · disclaimer system (approved by Mark):
   - per-ingredient 'Responsible use' rows are hidden via CSS
   - every claim line gets an asterisk
   - the single bottom block (.eri-disc) carries the standard FDA disclaimer,
     and the same asterisked disclaimer also lives in the site footer. */
(function () {
  function starClaims(scope) {
    scope.querySelectorAll('.eri-cardx .eri-tagline').forEach(function (el) {
      if (el.textContent.slice(-1) !== '*') el.textContent = el.textContent + '*';
    });
    scope.querySelectorAll('.eri-cardx .eri-r').forEach(function (row) {
      var b = row.querySelector('b');
      if (!b) return;
      if (b.textContent.indexOf('How we say it') === 0 || b.textContent.indexOf('What you feel') === 0) {
        if (row.textContent.slice(-1) !== '*') row.appendChild(document.createTextNode('*'));
      }
    });
  }
  function init() {
    var root = document.getElementById('eri-root');
    if (!root || root.dataset.eriDisc) return;
    root.dataset.eriDisc = '1';
    var disc = root.querySelector('.eri-disc');
    if (disc) {
      disc.innerHTML = '<b>*These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.</b> Individual responses vary. Do not combine with prescription medications, antidepressants, MAOIs, SSRIs, blood thinners, or blood-pressure medications unless cleared by a qualified healthcare professional. Not for children or pregnant or breastfeeding individuals without medical guidance.';
    }
    var grid = root.querySelector('[data-eri-grid]');
    if (grid) {
      starClaims(grid);
      new MutationObserver(function () { starClaims(grid); }).observe(grid, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* Ingredients page · mobile: the product-formula banner and the benefit filter
   row collapse behind two pill toggles so the sticky nav stays one row tall. */
(function () {
  function init() {
    var root = document.getElementById('eri-root');
    if (!root || root.dataset.eriMtg) return;
    var nav = root.querySelector('.eri-nav .eri-wrap');
    if (!nav) return;
    var ctx = nav.querySelector('[data-eri-ctx]');
    var filters = nav.querySelector('[data-eri-filters]');
    if (!filters) return;
    root.dataset.eriMtg = '1';

    var row = document.createElement('div');
    row.className = 'eri-mtoggles';
    var ctxBtn = document.createElement('button');
    ctxBtn.type = 'button'; ctxBtn.className = 'eri-mtg eri-mtg-ctx';
    ctxBtn.setAttribute('aria-expanded', 'false');
    var fBtn = document.createElement('button');
    fBtn.type = 'button'; fBtn.className = 'eri-mtg eri-mtg-filter';
    fBtn.setAttribute('aria-expanded', 'false');
    row.appendChild(ctxBtn); row.appendChild(fBtn);
    nav.insertBefore(row, nav.firstChild);

    function ctxName() {
      var n = ctx ? ctx.querySelector('[data-eri-ctxname]') : null;
      return n ? n.textContent.trim() : '';
    }
    function activeBenefit() {
      var a = filters.querySelector('.eri-chip.is-active');
      return a ? a.textContent.trim() : 'All';
    }
    function sync() {
      var hasCtx = ctx && ctx.classList.contains('show');
      ctxBtn.style.display = hasCtx ? '' : 'none';
      if (hasCtx) {
        var openC = ctx.classList.contains('eri-open');
        ctxBtn.innerHTML = 'Formula: <b>' + (ctxName() || 'product') + '</b> ' + (openC ? '▴' : '▾');
        ctxBtn.setAttribute('aria-expanded', openC ? 'true' : 'false');
      }
      var openF = filters.classList.contains('eri-open');
      fBtn.innerHTML = 'Filter: <b>' + activeBenefit() + '</b> ' + (openF ? '▴' : '▾');
      fBtn.setAttribute('aria-expanded', openF ? 'true' : 'false');
    }
    ctxBtn.addEventListener('click', function () {
      ctx.classList.toggle('eri-open');
      filters.classList.remove('eri-open');
      sync();
    });
    fBtn.addEventListener('click', function () {
      filters.classList.toggle('eri-open');
      if (ctx) ctx.classList.remove('eri-open');
      sync();
    });
    filters.addEventListener('click', function (e) {
      if (e.target.closest('.eri-chip')) { setTimeout(function () { filters.classList.remove('eri-open'); sync(); }, 150); }
    });
    if (ctx) {
      ctx.addEventListener('click', function (e) {
        if (e.target.closest('.eri-ctxchip') || e.target.closest('[data-eri-clearctx]')) {
          setTimeout(function () { ctx.classList.remove('eri-open'); sync(); }, 150);
        }
      });
      new MutationObserver(function () { sync(); }).observe(ctx, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
    sync();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
